import React from 'react';

/**
 * TODO - icons exist in several places, they should be consolidated.
 */

type TProps = {
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
  /** DEPRECATED - don't use this, use text-* class */
  stroke?: string;
  /** DEPRECATED - don't use this, use stroke-* class */
  strokeWidth?: string | number;
};

export const CancelIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="18"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12L10 10L8 12ZM10 10L12 8L10 10ZM10 10L8 8L10 10ZM10 10L12 12L10 10ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5H17M16 5L15.133 17.142C15.0971 17.6466 14.8713 18.1188 14.5011 18.4636C14.1309 18.8083 13.6439 19 13.138 19H4.862C4.35614 19 3.86907 18.8083 3.49889 18.4636C3.1287 18.1188 2.90292 17.6466 2.867 17.142L2 5H16ZM7 9V15V9ZM11 9V15V9ZM12 5V2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H7C6.73478 1 6.48043 1.10536 6.29289 1.29289C6.10536 1.48043 6 1.73478 6 2V5H12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="18"
    height="20"
    viewBox="0 0 20 20"
    stroke="currentColor"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5V13C5 13.5304 5.21071 14.0391 5.58579 14.4142C5.96086 14.7893 6.46957 15 7 15H13M5 5V3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H11.586C11.8512 1.00006 12.1055 1.10545 12.293 1.293L16.707 5.707C16.8946 5.89449 16.9999 6.1488 17 6.414V13C17 13.5304 16.7893 14.0391 16.4142 14.4142C16.0391 14.7893 15.5304 15 15 15H13M5 5H3C2.46957 5 1.96086 5.21071 1.58579 5.58579C1.21071 5.96086 1 6.46957 1 7V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H11C11.5304 19 12.0391 18.7893 12.4142 18.4142C12.7893 18.0391 13 17.5304 13 17V15"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DollarIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="18"
    height="20"
    viewBox="0 0 20 20"
    stroke="currentColor"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6C8.343 6 7 6.895 7 8C7 9.105 8.343 10 10 10C11.657 10 13 10.895 13 12C13 13.105 11.657 14 10 14V6ZM10 6C11.11 6 12.08 6.402 12.599 7L10 6ZM10 6V5V6ZM10 6V14V6ZM10 14V15V14ZM10 14C8.89 14 7.92 13.598 7.401 13L10 14ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    height="18"
    width="18"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    ></path>
  </svg>
);

export const PencilIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.424 2.92425L13.076 5.57625L10.424 2.92425ZM11.549 1.79925C11.9007 1.44757 12.3777 1.25 12.875 1.25C13.3723 1.25 13.8493 1.44757 14.201 1.79925C14.5527 2.15092 14.7502 2.6279 14.7502 3.12525C14.7502 3.62259 14.5527 4.09957 14.201 4.45125L3.875 14.7772H1.25V12.0982L11.549 1.79925V1.79925Z"
      stroke=""
      strokeOpacity="1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="white"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 5V1V5ZM14 5V1V5ZM5 9H15H5ZM3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    fill="none"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
    ></path>
  </svg>
);

export const DotIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="6"
    height="6"
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3" cy="3" r="3" fill="currentColor" />
  </svg>
);

export const ExternalLinkIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    height="24"
    width="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
    />
  </svg>
);

export const XIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);
export const ArrowRightIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CogIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0458 5.0365C12.5428 2.98783 15.4572 2.98783 15.9542 5.0365C16.0287 5.34427 16.1749 5.63008 16.3808 5.87067C16.5867 6.11126 16.8465 6.29983 17.1391 6.42104C17.4317 6.54224 17.7487 6.59266 18.0644 6.56818C18.3801 6.5437 18.6856 6.44502 18.956 6.28017C20.7562 5.1835 22.8177 7.24383 21.721 9.04517C21.5564 9.31543 21.4579 9.62073 21.4334 9.93624C21.409 10.2517 21.4594 10.5686 21.5804 10.8609C21.7015 11.1533 21.8899 11.413 22.1302 11.6189C22.3705 11.8248 22.656 11.9711 22.9635 12.0458C25.0122 12.5428 25.0122 15.4572 22.9635 15.9542C22.6557 16.0287 22.3699 16.1749 22.1293 16.3808C21.8887 16.5867 21.7002 16.8465 21.579 17.1391C21.4578 17.4317 21.4073 17.7487 21.4318 18.0644C21.4563 18.3801 21.555 18.6856 21.7198 18.956C22.8165 20.7562 20.7562 22.8177 18.9548 21.721C18.6846 21.5564 18.3793 21.4579 18.0638 21.4334C17.7483 21.409 17.4314 21.4594 17.1391 21.5804C16.8467 21.7015 16.587 21.8899 16.3811 22.1302C16.1752 22.3705 16.0289 22.656 15.9542 22.9635C15.4572 25.0122 12.5428 25.0122 12.0458 22.9635C11.9713 22.6557 11.8251 22.3699 11.6192 22.1293C11.4133 21.8887 11.1535 21.7002 10.8609 21.579C10.5683 21.4578 10.2513 21.4073 9.93558 21.4318C9.61986 21.4563 9.31438 21.555 9.044 21.7198C7.24383 22.8165 5.18233 20.7562 6.279 18.9548C6.44362 18.6846 6.54214 18.3793 6.56656 18.0638C6.59099 17.7483 6.54062 17.4314 6.41955 17.1391C6.29848 16.8467 6.11014 16.587 5.86982 16.3811C5.6295 16.1752 5.34399 16.0289 5.0365 15.9542C2.98783 15.4572 2.98783 12.5428 5.0365 12.0458C5.34427 11.9713 5.63008 11.8251 5.87067 11.6192C6.11126 11.4133 6.29983 11.1535 6.42104 10.8609C6.54224 10.5683 6.59266 10.2513 6.56818 9.93558C6.5437 9.61986 6.44502 9.31438 6.28017 9.044C5.1835 7.24383 7.24383 5.18233 9.04517 6.279C10.2072 6.98833 11.7238 6.36067 12.0458 5.0365Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 14C17.5 14.9283 17.1313 15.8185 16.4749 16.4749C15.8185 17.1313 14.9283 17.5 14 17.5C13.0717 17.5 12.1815 17.1313 11.5251 16.4749C10.8687 15.8185 10.5 14.9283 10.5 14C10.5 13.0717 10.8687 12.1815 11.5251 11.5251C12.1815 10.8687 13.0717 10.5 14 10.5C14.9283 10.5 15.8185 10.8687 16.4749 11.5251C17.1313 12.1815 17.5 13.0717 17.5 14V14Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BellIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 17.8333H7.50002M14.5 17.8333H20.3334L18.6942 16.1942C18.4741 15.974 18.2995 15.7126 18.1804 15.425C18.0612 15.1373 18 14.829 18 14.5177V10.8333C18.0002 9.38542 17.5515 7.97306 16.7158 6.7907C15.8801 5.60834 14.6983 4.71412 13.3334 4.23117V3.83333C13.3334 3.21449 13.0875 2.621 12.6499 2.18342C12.2123 1.74583 11.6189 1.5 11 1.5C10.3812 1.5 9.78769 1.74583 9.3501 2.18342C8.91252 2.621 8.66669 3.21449 8.66669 3.83333V4.23117C5.94835 5.1925 4.00002 7.786 4.00002 10.8333V14.5188C4.00002 15.1465 3.75035 15.7497 3.30585 16.1942L1.66669 17.8333H7.50002H14.5ZM14.5 17.8333V19C14.5 19.9283 14.1313 20.8185 13.4749 21.4749C12.8185 22.1313 11.9283 22.5 11 22.5C10.0718 22.5 9.18152 22.1313 8.52515 21.4749C7.86877 20.8185 7.50002 19.9283 7.50002 19V17.8333H14.5Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ArrowDownIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    height="15"
    width="15"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const CheckIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    height="20"
    width="20"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 13l4 4L19 7"
    ></path>
  </svg>
);

export const MilestoneCheckIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="10"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.24733 1.15835L3.28066 6.91669L1.69733 5.22502C1.40566 4.95002 0.94733 4.93335 0.613997 5.16669C0.288997 5.40835 0.19733 5.83335 0.39733 6.17502L2.27233 9.22502C2.45566 9.50835 2.77233 9.68336 3.13066 9.68336C3.47233 9.68336 3.79733 9.50835 3.98066 9.22502C4.28066 8.83335 10.0057 2.00835 10.0057 2.00835C10.7557 1.24169 9.84733 0.566688 9.24733 1.15002V1.15835Z"
      fill="currentColor"
    />
  </svg>
);

export const ClockIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="20"
    height="20"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.993 3.16311L12.0576 3.08647L11.9809 3.02204L9.4892 0.931209L9.41278 0.86708L9.34847 0.943353L8.64972 1.7721L8.5851 1.84873L8.66189 1.91317L11.1536 4.004L11.23 4.06813L11.2943 3.99186L11.993 3.16311ZM4.33252 1.91318L4.40903 1.849L4.34495 1.7724L3.65162 0.943646L3.58744 0.866932L3.51074 0.931127L1.01907 3.01654L0.942106 3.08096L1.0068 3.15769L1.70555 3.98644L1.76985 4.0627L1.84627 3.9986L4.33252 1.91318ZM6.87075 4.33365V4.23365H6.77075H5.95825H5.85825V4.33365V7.58365V7.64026L5.9068 7.66939L8.47972 9.21315L8.56486 9.26423L8.61655 9.17946L9.0228 8.51321L9.07552 8.42674L8.98839 8.37511L6.87075 7.12041V4.33365ZM6.49992 2.06698C3.75261 2.06698 1.52492 4.29467 1.52492 7.04198C1.52492 9.78922 3.74712 12.017 6.49992 12.017C9.24723 12.017 11.4749 9.78929 11.4749 7.04198C11.4749 4.29467 9.24723 2.06698 6.49992 2.06698ZM6.49992 10.7336C4.4589 10.7336 2.80825 9.083 2.80825 7.04198C2.80825 5.00096 4.4589 3.35031 6.49992 3.35031C8.54094 3.35031 10.1916 5.00096 10.1916 7.04198C10.1916 9.083 8.54094 10.7336 6.49992 10.7336Z"
      fill="#443100"
      stroke="current"
      strokeWidth="0.2"
    />
  </svg>
);
export const SearchIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M7.11572 14.1289C8.5835 14.1289 9.93701 13.6543 11.0444 12.8633L15.2104 17.0293C15.4038 17.2227 15.6587 17.3193 15.9312 17.3193C16.5024 17.3193 16.9067 16.8799 16.9067 16.3174C16.9067 16.0537 16.8188 15.8076 16.6255 15.6143L12.4858 11.4658C13.356 10.3232 13.8745 8.9082 13.8745 7.37012C13.8745 3.65234 10.8335 0.611328 7.11572 0.611328C3.39795 0.611328 0.356934 3.65234 0.356934 7.37012C0.356934 11.0879 3.39795 14.1289 7.11572 14.1289ZM7.11572 12.6699C4.21533 12.6699 1.81592 10.2705 1.81592 7.37012C1.81592 4.46973 4.21533 2.07031 7.11572 2.07031C10.0161 2.07031 12.4155 4.46973 12.4155 7.37012C12.4155 10.2705 10.0161 12.6699 7.11572 12.6699Z"
      fill="black"
    />
  </svg>
);

export const AddIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
    />
  </svg>
);

export const Eye = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);

export const Mail = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    height="24"
    width="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    ></path>
  </svg>
);

export const PlusCircleIcon = ({
  className,
  style,
  stroke,
  strokeWidth
}: TProps) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth || 2}
    stroke={stroke || 'currentColor'}
    height="16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const Notice = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    height="24"
    width="24"
    viewBox="0 0 18 18"
    stroke="currentColor"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V4C1 4.26522 1.10536 4.51957 1.29289 4.70711C1.48043 4.89464 1.73478 5 2 5H16C16.2652 5 16.5196 4.89464 16.7071 4.70711C16.8946 4.51957 17 4.26522 17 4V2C17 1.73478 16.8946 1.48043 16.7071 1.29289C16.5196 1.10536 16.2652 1 16 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289Z"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.29289 9.29289C1.10536 9.48043 1 9.73478 1 10V16C1 16.2652 1.10536 16.5196 1.29289 16.7071C1.48043 16.8946 1.73478 17 2 17H8C8.26522 17 8.51957 16.8946 8.70711 16.7071C8.89464 16.5196 9 16.2652 9 16V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9H2C1.73478 9 1.48043 9.10536 1.29289 9.29289Z"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2929 9.29289C13.1054 9.48043 13 9.73478 13 10V16C13 16.2652 13.1054 16.5196 13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17H16C16.2652 17 16.5196 16.8946 16.7071 16.7071C16.8946 16.5196 17 16.2652 17 16V10C17 9.73478 16.8946 9.48043 16.7071 9.29289C16.5196 9.10536 16.2652 9 16 9H14C13.7348 9 13.4804 9.10536 13.2929 9.29289Z"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlarmNote = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="20"
    height="22"
    viewBox="0 0 18 20"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6L9.00448 10.5M9 13.25H9.00448M17 19V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19L5 17L9 19L13 17L17 19Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusNote = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="20"
    height="22"
    viewBox="0 0 18 20"
    stroke="currentColor"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.57144 9.1111H9.00001M9.00001 9.1111H12.4286M9.00001 9.1111V5.77777M9.00001 9.1111V12.4444M17 19V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19L5 17L9 19L13 17L17 19Z"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TickNote = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 8.5L8 10.5L12.5 6M17 19V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V19L3.75 17L6.25 19L9 17L11.75 19L14.25 17L17 19Z"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExclamationCircle = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    stroke="currentColor"
    viewBox="-2 -1.5 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6V10M10 14H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** TODO - don't pass stroke in, use tw classes which will impact currentColor */
export const BuildingIcon = ({
  className,
  style,
  stroke
}: TProps & { stroke?: string }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 22 20"
    height="50%"
    width="50%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke || 'currentColor'}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.5 9H3.6C3.03995 9 2.75992 9 2.54601 9.10899C2.35785 9.20487 2.20487 9.35785 2.10899 9.54601C2 9.75992 2 10.0399 2 10.6V19M15.5 9H18.4C18.9601 9 19.2401 9 19.454 9.10899C19.6422 9.20487 19.7951 9.35785 19.891 9.54601C20 9.75992 20 10.0399 20 10.6V19M15.5 19V4.2C15.5 3.0799 15.5 2.51984 15.282 2.09202C15.0903 1.71569 14.7843 1.40973 14.408 1.21799C13.9802 1 13.4201 1 12.3 1H9.7C8.57989 1 8.01984 1 7.59202 1.21799C7.21569 1.40973 6.90973 1.71569 6.71799 2.09202C6.5 2.51984 6.5 3.0799 6.5 4.2V19M21 19H1M10 5H12M10 9H12M10 13H12"
    />
  </svg>
);

export const BalanceIcon = ({ className, style }: TProps) => (
  <svg
    width="20"
    style={style}
    height="22"
    viewBox="0 0 14 14"
    className={className}
    fill="none"
  >
    <path
      d="M1 2.99989L2.99989 3.66652M2.99989 3.66652L1 9.66618C1.5771 10.0989 2.27894 10.3327 3.00022 10.3327C3.72151 10.3327 4.42334 10.0989 5.00044 9.66618L2.99989 3.66652ZM2.99989 3.66652L4.99978 9.66618M2.99989 3.66652L6.99967 2.33326M6.99967 2.33326L10.9994 3.66652M6.99967 2.33326V1M6.99967 2.33326V12.9993M10.9994 3.66652L12.9993 2.99989M10.9994 3.66652L8.99956 9.66618C9.57666 10.0989 10.2785 10.3327 10.9998 10.3327C11.7211 10.3327 12.4229 10.0989 13 9.66618L10.9994 3.66652ZM6.99967 12.9993H4.99978M6.99967 12.9993H8.99956"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TickIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 4L4.58333 7L10.25 1"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CommunityProfiles = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 17H21V15C21 14.3765 20.8057 13.7686 20.4441 13.2606C20.0826 12.7527 19.5718 12.37 18.9827 12.1658C18.3937 11.9615 17.7556 11.9459 17.1573 12.121C16.5589 12.2962 16.03 12.6534 15.644 13.143M16 17H6M16 17V15C16 14.344 15.874 13.717 15.644 13.143M15.644 13.143C15.2726 12.215 14.6318 11.4195 13.804 10.8591C12.9762 10.2988 11.9996 9.9993 11 9.9993C10.0004 9.9993 9.02376 10.2988 8.196 10.8591C7.36825 11.4195 6.72736 12.215 6.356 13.143M6 17H1V15C1.00005 14.3765 1.19434 13.7686 1.55586 13.2606C1.91739 12.7527 2.42819 12.37 3.01725 12.1658C3.60632 11.9615 4.24438 11.9459 4.84274 12.121C5.4411 12.2962 5.97003 12.6534 6.356 13.143M6 17V15C6 14.344 6.126 13.717 6.356 13.143M14 4C14 4.79565 13.6839 5.55871 13.1213 6.12132C12.5587 6.68393 11.7956 7 11 7C10.2044 7 9.44129 6.68393 8.87868 6.12132C8.31607 5.55871 8 4.79565 8 4C8 3.20435 8.31607 2.44129 8.87868 1.87868C9.44129 1.31607 10.2044 1 11 1C11.7956 1 12.5587 1.31607 13.1213 1.87868C13.6839 2.44129 14 3.20435 14 4ZM20 7C20 7.53043 19.7893 8.03914 19.4142 8.41421C19.0391 8.78929 18.5304 9 18 9C17.4696 9 16.9609 8.78929 16.5858 8.41421C16.2107 8.03914 16 7.53043 16 7C16 6.46957 16.2107 5.96086 16.5858 5.58579C16.9609 5.21071 17.4696 5 18 5C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7ZM6 7C6 7.53043 5.78929 8.03914 5.41421 8.41421C5.03914 8.78929 4.53043 9 4 9C3.46957 9 2.96086 8.78929 2.58579 8.41421C2.21071 8.03914 2 7.53043 2 7C2 6.46957 2.21071 5.96086 2.58579 5.58579C2.96086 5.21071 3.46957 5 4 5C4.53043 5 5.03914 5.21071 5.41421 5.58579C5.78929 5.96086 6 6.46957 6 7Z"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningTriangle = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.366655 17L9.99734 0.636363L19.628 17H0.366655ZM9.99734 15.1179C10.3714 15.1179 10.691 14.9853 10.9561 14.7202C11.226 14.4503 11.361 14.1283 11.361 13.7543C11.361 13.3802 11.226 13.0606 10.9561 12.7955C10.691 12.5303 10.3714 12.3977 9.99734 12.3977C9.62328 12.3977 9.30131 12.5303 9.03143 12.7955C8.76628 13.0606 8.6337 13.3802 8.6337 13.7543C8.6337 14.1283 8.76628 14.4503 9.03143 14.7202C9.30131 14.9853 9.62328 15.1179 9.99734 15.1179ZM9.00302 10.8778H10.9917L11.1053 6.09091H8.88938L9.00302 10.8778Z"
      fill="#203B52"
    />
  </svg>
);

export const MilestoneDiagonalArrowIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.25 1.5L8.5 1.5M8.5 1.5V6.75M8.5 1.5L1.5 8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QuestionMarkWithCircleIcon = ({ className, style }: TProps) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.05992 6.00004C6.21665 5.55449 6.52602 5.17878 6.93322 4.93946C7.34042 4.70015 7.81918 4.61267 8.2847 4.69252C8.75022 4.77236 9.17246 5.01439 9.47664 5.37573C9.78081 5.73706 9.94729 6.19439 9.94659 6.66671C9.94659 8.00004 7.94659 8.66671 7.94659 8.66671M7.99992 11.3334H8.00659M14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilledCircleIcon = ({ className, style }: TProps) => (
  <svg
    width="16"
    style={style}
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM11.707 6.707C11.8892 6.5184 11.99 6.2658 11.9877 6.0036C11.9854 5.7414 11.8802 5.49059 11.6948 5.30518C11.5094 5.11977 11.2586 5.0146 10.9964 5.01233C10.7342 5.01005 10.4816 5.11084 10.293 5.293L7 8.586L5.707 7.293C5.5184 7.11084 5.2658 7.01005 5.0036 7.01233C4.7414 7.0146 4.49059 7.11977 4.30518 7.30518C4.11977 7.49059 4.0146 7.7414 4.01233 8.0036C4.01005 8.2658 4.11084 8.5184 4.293 8.707L6.293 10.707C6.48053 10.8945 6.73484 10.9998 7 10.9998C7.26516 10.9998 7.51947 10.8945 7.707 10.707L11.707 6.707Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningIcon = ({ className, style }: TProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
      clipRule="evenodd"
      stroke="currentColor"
    />
  </svg>
);

export const AddImageIcon = ({ className, style }: TProps) => (
  <svg
    stroke="currentColor"
    style={style}
    fill="none"
    viewBox="0 0 48 48"
    className={className}
  >
    <path
      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
